<script lang="ts">
    import { ProgrammaImplementazione } from "../../../models/PSCL/Schema/PSCLSchemaProgettazione";

    export let data: ProgrammaImplementazione = new ProgrammaImplementazione();
</script>

<div class="flex justify-center mt-2">
    <div class="w-full">
        <div class="mt-2">
            <table class="w-full text-xs border border-black table-fixed">
                <thead>
                    <tr>
                        <th class="border border-black">Misura</th>
                    <!--
                        <th class="border border-black">Data</th>
                        <th class="border border-black">Costo di implementazione</th>
                        <th class="border border-black">Costo di gestione</th>
                        <th class="border border-black">Note</th>
                    -->
                        <th class="border border-black">Implementata</th>
                    </tr>
                </thead>
                <tbody>
                    {#if data?.misure?.length > 0}
                        {#each data.misure as misura}
                            <tr>
                                <td class="text-center border border-black">{misura?.misura}</td>
                            <!--
                                <td class="text-center border border-black">{misura?.data !== undefined ? formatDate(misura.data) : ''}</td>
                                <td class="text-center border border-black">{formatNumberWithSeparators(misura?.costoImplementazione)}€</td>
                                <td class="text-center border border-black">{formatNumberWithSeparators(misura?.costoGestione)}€</td>
                                <td class="text-center border border-black">{misura?.note}</td>
                            -->
                                <td class="text-center border border-black">{misura?.applicata ? 'Sì' : 'No'}</td>
                            </tr>
                        {/each}
                    {:else}
                        <tr>
                            <td class="text-center bg-blue-100 border border-black" colspan="6">Nessuna misura disponibile</td>
                        </tr>
                    {/if}
                    <!--
                    <tr>
                        <td class="text-center border border-black" colspan="2"><strong>Totale</strong></td>
                        <td class:bg-blue-100={!data?.costoTotaleImplementazione} class="text-center border border-black"><strong>{formatNumberWithSeparators(data?.costoTotaleImplementazione) || 0}€</strong></td>
                        <td class:bg-blue-100={!data?.costoTotaleGestione} class="text-center border border-black"><strong>{formatNumberWithSeparators(data?.costoTotaleGestione) || 0}€</strong></td>
                        <td class="text-center border border-black" colspan="2"></td>
                    </tr>
                    -->
                </tbody>
            </table>
        </div>
    </div>
</div>